import * as React from "react";
import { Button } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { cloneDeep, get } from "lodash";
import { store } from "../../../store";
import { formSet, formSetValue, formTriggerValidation } from "../../gvc/testNewForm/utils";
import { FormListFieldItem } from "../../gvc/formListFieldItem";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpSelect } from "../../gvc/testNewForm/CpSelect";
import { QueryInputTerm, QueryInputTermTypeOptions, QueryTermOperatorOptions } from "../../../schema/types/query/input";
import { OPERATORS_REQUIRING_TWO_VALUES, queryProperties } from "../../../services/utils";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface Props {
  name?: string;
  item?: QueryInputTerm;
  index?: number;
  kind?: string;
}
export const CpArrayItemQueryTerm: React.FC<Props> = React.memo(({ name: _name, item: _item, index: _index, kind }) => {
  const { id } = useCpFormContext();

  const name = _name!;
  const item = _item!;
  const index = _index!;

  const allowedProperties: string[] = (queryProperties as any)[kind!] || [];
  const hasAllowedProperties = allowedProperties.length > 0;
  const propertyOptions = allowedProperties.map((p) => ({ label: p, value: p }));

  function remove() {
    const form = store.getState().form.instances[id];
    const values = form.values;
    const items = get(values, name) || [];
    let _items = cloneDeep(items);
    _items = _items.filter((i) => i.id !== item.id);
    formSetValue(id, name, _items);

    formTriggerValidation(id);
  }

  return (
    <FormListFieldItem columnCount={6} hasRemoveButton className="mb-1">
      <CpSelect
        name={`${name}.${index}.termType`}
        options={QueryInputTermTypeOptions}
        style={{ width: "100%" }}
        className={`col-span-1`}
      />
      {item.termType === "property" && hasAllowedProperties ? (
        <CpSelect name={`${name}.${index}.key`} options={propertyOptions} className={`col-span-2`} />
      ) : (
        <CpInput name={`${name}.${index}.key`} className={`col-span-2`} />
      )}
      <CpSelect
        name={`${name}.${index}.op`}
        options={QueryTermOperatorOptions}
        style={{ width: "100%" }}
        className={`col-span-1`}
      />
      {/* TODO validation here is not triggered, add dependency for validation triggering */}
      <CpInput
        name={`${name}.${index}.value`}
        // validations={OPERATORS_REQUIRING_TWO_VALUES.includes(term.op) ? ["required"] : undefined}
        className={`col-span-2`}
        disabled={!OPERATORS_REQUIRING_TWO_VALUES.includes(item.op)}
      />

      <Button type={`text`} danger icon={<MinusCircleOutlined />} onClick={() => remove()} />
    </FormListFieldItem>
  );
});
